<template>
  <div>
    <section id="hero" aria-labelledby="hero-heading">
      <div class="container">
        <div class="row">
          <div
            class="col-md-7 col-xs-12 img_section hidden-md hidden-lg hidden-sm"
          >
            <img
              src="../assets/home page banner mobile.png"
              class="img-responsive home_page_banner"
              alt=""
              role="presentation"
              aria-hidden="true"
            />
          </div>
          <div class="col-md-5 col-sm-5 col-xs-12">
            <h1 id="hero-heading" class="mb-4">Invest Smartly</h1>
            <p class="hero-sub mb-4">
              Become a smart investor and create wealth with our best in class
              recommendations and simplified analysis.
            </p>
            <router-link to="/pricing" class="btn btn_custom mt-2"
              >Get Started</router-link
            >
          </div>
          <div class="col-md-7 col-sm-7 img_section hidden-xs">
            <img
              src="../assets/home page banner 1.png"
              class="img-responsive home_page_banner"
              alt=""
              role="presentation"
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- <section> -->
      <!-- <home-graph></home-graph> -->
    <!-- </section> -->
    <div class="band" id="services">
      <div class="container">
        <div class="row">
          <h2 class="center_heading hidden-xs">
            What GROW WITH STOCKS can do for you ?
          </h2>
          <h2 class="center_heading visible-xs">
            What <br />
            GROW WITH STOCKS <br />
            can do for you ?
          </h2>
        </div>
      </div>
    </div>
    <!-- <section class="services">
      <div class="container">
        <div class="row">
          <div class="col-md-6 img_section col-xs-12 col-sm-6">
            <CummilativeGraph />
          </div>
          <div class="col-md-5 col-md-offset-1 col-xs-12 col-sm-6">
            <h1 class="mb-4">Performance</h1>
            <ul>
              <li>
                <strong> Hard-hitting </strong> and
                <strong> Profit-Yielding </strong> stocks that will generate
                returns close to <strong> 150% to 300% over 2 years </strong> of
                investment.
              </li>
              <li>
                Recommendation of Non-conventional aggressive stocks to maximize
                your profits
              </li>
              <li>
                Recommendations based on thorough research and knowledge based
                real market facts.
              </li>
              <li>
                <router-link class="know_more_link" to="/faq"
                  >Know more</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section> -->
    <section class="services">
      <div class="container">
        <div class="row">
          <div
            class="col-md-5 col-md-offset-2 img_section col-sm-12 col-sm-5 hidden-md hidden-lg hidden-sm"
          >
            <img
              src="../assets/Timely Support.png"
              class="img-responsive"
              alt=""
              role="presentation"
              aria-hidden="true"
            />
          </div>
          <div class="col-md-5 col-sm-7 col-xs-12">
            <h3 class="mb-4 service-heading">Timely Support</h3>
            <ul>
              <li>
                Clear <strong> Buy, Sell and Hold </strong>instructions &amp;
                timely updates for every stock in the portfolio, so you can make
                your decisions as simply as <strong>1-2-3</strong>
              </li>
              <li><strong> Direct Q&amp;A </strong> with the experts.</li>
            </ul>
            <!-- <p class="know_more_wrap">
              <router-link class="know_more_link" to="/faq"
                >Know more about Timely Support</router-link
              >
            </p> -->
          </div>
          <div class="col-md-5 col-md-offset-2 img_section col-sm-5 hidden-xs">
            <img
              src="../assets/Timely Support.png"
              class="img-responsive"
              alt=""
              role="presentation"
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="services">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-6 col-xs-12 img_section">
            <img
              src="../assets/Easy to Understand Reports.png"
              class="img-responsive"
              alt=""
              role="presentation"
              aria-hidden="true"
            />
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <h3 class="mb-4 service-heading">Easy to understand reports</h3>
            <ul>
              <li>Special Reports on economic and market conditions</li>
              <li>
                Easy to understand reports containing relevant information, WOW
                factor, analysis, buy and sell range for 2 -3 years
              </li>
              <li>
                Research based on company’s fundamentals instead of charts.
              </li>
            </ul>
            <!-- <p class="know_more_wrap">
              <router-link class="know_more_link" to="/faq"
                >Know more about our reports</router-link
              >
            </p> -->
          </div>
        </div>
      </div>
    </section>
    <section id="testimonials">
      <div class="container">
        <div class="row">
          <div
            class="col-md-4 col-xs-8 col-xs-offset-2 img_section col-sm-4 hidden-md hidden-lg hidden-sm"
          >
            <img
              src="../assets/gws_home_testimonials copy.png"
              class="img-responsive"
              alt="Grow With Stocks Happy Customer"
            />
          </div>
          <div class="col-md-8 col-sm-8 col-xs-12">
            <div class="container">
              <q>
                I am a member of Grow With Stocks since 2013. The Investment of
                mine in year 2013 have appreciated to more than 100% during the
                period of 17 months.
                <br />
                I am very happy to recommend G.W.S Consultants to any of my
                friends interested in having a consultancy services to help
                their investment in Equity Market. Their monthly recommendation
                of Stocks, weekly/fortnightly personal contacts helps to
                generate and maintain a highly profitable portfolio.
              </q>
              <p class="mt-2">
                <strong> - Jayarajan M Varkala, investor since 2013 </strong>
              </p>
            </div>
          </div>
          <div class="col-md-4 img_section col-sm-4 hidden-xs">
            <img
              src="../assets/gws_home_testimonials copy.png"
              class="img-responsive"
              alt="Grow With Stocks Happy Customer"
            />
          </div>
        </div>
      </div>
    </section>
    <section id="whyUs" aria-labelledby="why-us-heading">
      <div class="container">
        <h2 id="why-us-heading">Why Us ?</h2>
        <div class="row mt-5">
          <div class="col-md-4 col-sm-4">
            <i class="fas fa-pencil-ruler mt-4" aria-hidden="true"></i>
            <h3 class="mt-4">Designed for Every Investor</h3>
            <p class="mt-4">
              Whether you are a small, big, newbie or a veteran investor, we
              have you covered.
            </p>
          </div>
          <div class="col-md-4 col-sm-4">
            <i class="fas fa-chart-line mt-4" aria-hidden="true"></i>
            <h3 class="mt-4">
              Investment Approach
            </h3>
            <p class="mt-4">
              We follow a disciplined and research-based investment process focused on long-term value creation.
            </p>
          </div>
          <div class="col-md-4 col-sm-4">
            <i class="fas fa-hand-holding-usd mt-4" aria-hidden="true"></i>
            <h3 class="mt-4">
              We Actually Care
            </h3>
            <p class="mt-4">
              We understand your specific needs even before the subscription and
              guide you along the way. We’re here for you at every step with
              investing guidance, email and tele-support step-by-step tutorials
              and more.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section id="subscribe" aria-labelledby="subscribe-heading">
      <div class="container-fluid contact_us_form">
        <div class="row">
          <div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-4 col-md-offset-4">
            <h2 id="subscribe-heading" class="h3 text-center white--text">
              Claim your free trial stocks
            </h2>
            <form v-on:submit.prevent="onSubmit" class="pa-4 elevation-1" novalidate>
              <label for="home-name" class="white--text form-label">Name <span aria-hidden="true">*</span></label>
              <input
                id="home-name"
                type="text"
                placeholder="Your name"
                class="form-control form-control-lg my-2"
                required
                autocomplete="name"
                aria-required="true"
                :aria-invalid="nameErrors.length > 0"
                aria-describedby="home-name-error"
                v-model="name"
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
              />
              <p id="home-name-error" class="white--text form-error" role="alert" aria-live="polite" v-if="nameErrors.length">
                {{ nameErrors[0] }}
              </p>
              <label for="home-email" class="white--text form-label">Email Address <span aria-hidden="true">*</span></label>
              <input
                id="home-email"
                type="email"
                placeholder="you@example.com"
                class="form-control form-control-lg my-2"
                required
                autocomplete="email"
                aria-required="true"
                :aria-invalid="emailErrors.length > 0"
                aria-describedby="home-email-error"
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
                v-model="email"
              />
              <p id="home-email-error" class="white--text form-error" role="alert" aria-live="polite" v-if="emailErrors.length">
                {{ emailErrors[0] }}
              </p>
              <label for="home-mobile" class="white--text form-label">Mobile Number <span aria-hidden="true">*</span></label>
              <input
                id="home-mobile"
                type="tel"
                placeholder="10-digit mobile"
                class="form-control form-control-lg my-2"
                required
                autocomplete="tel"
                inputmode="numeric"
                pattern="[0-9]{10}"
                aria-required="true"
                :aria-invalid="mobileErrors.length > 0"
                aria-describedby="home-mobile-error"
                v-model="mobile"
                @input="$v.mobile.$touch()"
                @blur="$v.mobile.$touch()"
              />
              <p id="home-mobile-error" class="white--text form-error" role="alert" aria-live="polite" v-if="mobileErrors.length">
                {{ mobileErrors[0] }}
              </p>
              <p class="white--text required-note"><span aria-hidden="true">*</span> indicates a required field</p>
              <button type="submit" class="btn btn_custom btn_contact mt-3">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HomeGraph from "../components/HomeGraph.vue";
import CummilativeGraph from "../components/CummilativeGraph.vue";
import lb from "../util/lb";
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, maxLength, email, numeric } from "vuelidate/lib/validators";

export default {
  name: "Home",
  components: {
    HomeGraph,
    CummilativeGraph
  },
  computed: {
    ...mapGetters(["user"]),
    mobileErrors() {
      const errors = [];
      if (!this.$v.mobile.$dirty) return errors;
      !this.$v.mobile.required && errors.push("Mobile Number is required.");
      !this.$v.mobile.maxLength && errors.push("Enter correct Mobile Number.");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push("Name is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    }
  },
  validations: {
    name: { required },
    email: { required, email },
    mobile: { numeric, required, maxLength: maxLength(10) }
  },
  data() {
    return {
      name: null,
      email: null,
      mobile: null,
      level: null
    };
  },
  methods: {
    getFreeReport() {
      if (this.user) {
        this.$toasted.show(
          "You will receive a sample report at your email within 24 hours.",
          {
            duration: 5000,
            position: "bottom-right"
          }
        );
      } else {
        this.$router.push("login?source=free_report");
      }
    },
    addUserToSubscriberList() {
      lb.post("/api/Subscriptions/addusertomailchimp", {
        data: {
          type: "free subscription",
          email: this.email
        }
      })
        .then(() => {
          this.email = null;
          this.$toasted.show(
            "Your email is successfully added to our weekly newsletter.",
            {
              position: "bottom-right",
              duration: 2000
            }
          );
        })
        .catch(e => {
          this.$toasted.error(e.message, {
            position: "bottom-right",
            duration: 2000
          });
          console.log(e);
        });
    },
    async onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          const response = await lb.post("/api/Messages/sendContactUsDetails", {
            contactInfo: {
              name: this.name,
              level: "New lead from home page",
              email: this.email,
              mobile: this.mobile
            }
          });
          this.$v.$reset();
          this.name = null;
          this.email = null;
          this.mobile = null;
          this.$toasted.show(
            "Thanks for your query, we will contact you shortly.",
            {
              duration: 5000,
              position: "top-center"
            }
          );
        } catch (err) {
          console.log(err);
          this.$toasted.show("Oops some error occurred", {
            duration: 2000,
            position: "bottom-right"
          });
        }
      }
    }
  }
};
</script>

<style lang="scss">
section {
  margin-bottom: 24px;
  h1, h2, h3 {
    font-weight: 700;
  }
  h1 { font-size: 36px; line-height: 42px; }
  h2 { font-size: 30px; line-height: 38px; }
  h3 { font-size: 22px; line-height: 28px; }
  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #595959; /* WCAG AA on white: 7:1 */
  }
  .know_more_link {
    color: #1a7055;
    text-decoration: underline;
    font-weight: 600;
  }
  .know_more_link:hover,
  .know_more_link:focus {
    color: #0d3d2e;
  }
  /* Wrapper for the "Know more" link after it was lifted out of the feature
     <ul> to avoid SR announcing "list of 1". Keeps the original visual
     indent + vertical rhythm. */
  .know_more_wrap {
    margin: 15px 0 0;
    padding-left: 24px;
    font-size: 16px;
    line-height: 26px;
  }
}
#hero {
  margin-top: 60px;
  margin-bottom: 0;
  padding-bottom: 24px;
  h1 {
    font-weight: 800;
    font-size: 60px;
    line-height: 64px;
    color: #040d14;
    letter-spacing: -1px;
  }
  .hero-sub {
    font-weight: 400;
    font-size: 20px;
    color: #595959;
    line-height: 30px;
  }
  .home_page_banner {
    max-width: 110%;
    position: relative;
    bottom: 5vh;
  }
  .btn_custom {
    background-color: #1a7055;
    color: #fff;
    font-weight: 600;
    margin: auto;
    height: 50px;
    width: auto;
    display: inline-block;
    padding: 12px 28px;
    border-radius: 6px;
    text-decoration: none;
    border: 2px solid transparent;
    box-shadow: 0 4px 12px rgba(26, 112, 85, 0.25);
    transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  }
  .btn_custom:hover,
  .btn_custom:focus {
    background-color: #0d3d2e;
    color: #fff;
    text-decoration: none;
    transform: translateY(-2px);
    box-shadow: 0 8px 18px rgba(13, 61, 46, 0.30);
  }
  .btn_custom:focus-visible {
    outline: 3px solid #ffbf47;
    outline-offset: 2px;
    /* Pair amber with dark halo so focus is visible on dark green button fill. */
    box-shadow:
      0 0 0 2px #0d3d2e,
      0 0 0 7px rgba(13, 61, 46, 0.55),
      0 8px 18px rgba(13, 61, 46, 0.30);
  }
}
.services {
  padding-top: 48px;
  padding-bottom: 48px;
  img {
    width: 75%;
    height: auto;
    transition: transform 0.4s ease;
  }
  img:hover {
    transform: scale(1.03);
  }
  h2, .service-heading {
    font-weight: 800;
    font-size: 32px;
    line-height: 42px;
    color: #040d14;
    position: relative;
    padding-bottom: 12px;
    letter-spacing: -0.3px;
  }
  h2::after,
  .service-heading::after {
    content: "";
    display: block;
    width: 48px;
    height: 4px;
    background: #1a7055;
    border-radius: 2px;
    margin-top: 12px;
  }
  ul {
    padding-left: 0;
    li {
      margin: 15px 0;
      font-size: 16px;
      font-weight: 400;
      line-height: 26px;
      color: #595959;
      list-style: none;
      position: relative;
      padding-left: 24px;
    }
    li::before {
      /* Decorative tick: empty alt text ("/ \"\"") keeps NVDA/VoiceOver from announcing the ✔ */
      content: "\2714" / "";
      color: #1a7055;
      font-weight: 700;
      position: absolute;
      left: 0;
      top: 0;
    }
    li:has(.know_more_link)::before {
      content: "";
    }
  }
}
q {
  font-weight: 300;
  font-size: 17px;
  line-height: 30px;
}
#testimonials {
  padding-top: 32px;
  padding-bottom: 32px;
  .container .container q {
    display: block;
  }
  q {
    color: #2d2d2d;
  }
  p strong {
    color: #1a1a1a;
  }
}
#whyUs {
  padding-top: 48px;
  padding-bottom: 48px;
  text-align: center;
  h2 {
    text-align: center;
    position: relative;
    padding-bottom: 16px;
    margin-bottom: 24px;
  }
  h2::after {
    content: "";
    display: block;
    width: 64px;
    height: 4px;
    background: #1a7055;
    border-radius: 2px;
    margin: 16px auto 0;
  }
  i {
    font-size: 36px;
    color: #1a7055;
    background: rgba(26, 112, 85, 0.08);
    width: 88px;
    height: 88px;
    line-height: 88px;
    border-radius: 50%;
    display: inline-block;
    transition: transform 0.3s ease, background-color 0.3s ease;
  }
  .col-md-4:hover i {
    transform: translateY(-4px);
    background: rgba(26, 112, 85, 0.15);
  }
  h3 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: #1a1a1a;
  }
  p {
    max-width: 320px;
    margin-left: auto;
    margin-right: auto;
  }
}
#subscribe {
  background-color: #000;
  padding-top: 48px;
  padding-bottom: 48px;
  margin-bottom: 0;
  .contact_us_form {
    background-color: #000;
    h2 {
      font-size: 2.2em;
      color: #fff;
    }
    form {
      border-radius: 10px;
      input {
        height: 50px;
        color: #000;
        background-color: #fff;
      }
      input::placeholder {
        color: #595959; /* AA on white */
        opacity: 1;
      }
      input:focus {
        outline: 3px solid #ffbf47;
        outline-offset: 2px;
      }
      .form-label {
        display: block;
        font-size: 14px;
        font-weight: 600;
        margin-top: 12px;
        margin-bottom: 4px;
        color: #fff;
      }
      .form-error {
        font-size: 13px;
        color: #ffd2d2;
        font-weight: 600;
        margin: 4px 0 0;
      }
      .required-note {
        font-size: 12px;
        color: #d4d4d4;
        margin-top: 12px;
      }
    }
    .btn_custom {
      background-color: #ffd54a !important; /* AAA on black */
      font-weight: 800;
      display: block;
      margin: 10px auto;
      height: 70px;
      width: 100%;
      max-width: 300px;
      color: #000;
      font-size: 1.6em;
      border: 2px solid transparent;
    }
    .btn_custom:hover,
    .btn_custom:focus {
      background-color: #ffe082 !important;
      color: #000;
    }
    .btn_custom:focus-visible {
      outline: 3px solid #fff;
      outline-offset: 2px;
    }
  }
}
.center_heading {
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
}
.bgc_grey {
  background-color: #f1f1f1;
}
#services {
  margin-top: 24px;
}
.band {
  background: #ffffff;
  color: #1a7055;
  padding: 16px 0 12px;
  border-bottom: 1px solid #ececec;
  h2 {
    color: #1a7055;
    position: relative;
    padding-bottom: 8px;
    margin-top: 0;
    margin-bottom: 0;
  }
  h2::after {
    content: "";
    display: block;
    width: 64px;
    height: 3px;
    background: #1a7055;
    border-radius: 2px;
    margin: 8px auto 0;
  }
}
.free_report_section {
  background-color: #000;
  padding-top: 3vh;
  height: 35vh;
  text-align: left;
  button {
    width: 40%;
    background-color: #fff;
    color: #000;
    margin-top: 10px;
    font-weight: 600;
    height: 50px;
    border-radius: 4px;
  }
}
.free_subscribe_section {
  // background-color: #31cc9a;
  background: rgba(49, 204, 153, 0.8);
  background: -webkit-linear-gradient(
    to right,
    #31cc9a,
    #7cf8d1
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #31cc9a,
    #7cf8d1
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  height: 35vh;
  padding-top: 3vh;
  text-align: left;
  button {
    width: 40%;
    background-color: #fff;
    color: #31cc9a;
    font-weight: 600;
    height: 50px;
    border-radius: 4px;
    margin: 10px auto;
    display: block;
  }
}
/*==========  Mobile First Method  ==========*/

/* Custom, iPhone Retina */
@media only screen and (min-width: 320px) {
}

/* Extra Small Devices, Phones */
@media only screen and (min-width: 480px) {
}

/* Small Devices, Tablets */
@media only screen and (min-width: 768px) {
}

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {
}

/* Large Devices, Wide Screens */
@media only screen and (min-width: 1200px) {
}

/*==========  Non-Mobile First Method  ==========*/

/* Large Devices, Wide Screens */
@media only screen and (max-width: 1200px) {
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
}

@media screen and (max-width: 1024px) {
  #hero {
    margin-top: 48px;
    h1 {
      font-weight: 700;
      font-size: 48px;
      line-height: 50px;
      color: #040d14;
    }
    h4 {
      font-weight: 400;
      font-size: 17px;
      color: #696969;
      line-height: 24px;
    }
    .btn_custom {
      margin: 0px !important;
    }
  }
  .center_heading {
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    line-height: 42px;
  }
  .services h1 {
    font-weight: 700;
    font-size: 26px;
    line-height: 36px;
    color: #040d14;
  }
  .services ul li {
    margin: 11px 0;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #696969;
    list-style: none;
  }
  q {
    font-weight: 300;
    font-size: 16px;
    line-height: 25px;
  }
  #whyUs h4 {
    font-weight: 700;
    font-size: 18px;
    line-height: 12px;
  }
  #whyUs p {
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
    color: #696969;
  }
  .free_report_section {
    height: 45vh;
    h2 {
      margin-top: 0px;
      font-size: 23px;
    }
    p {
      margin: 0px;
    }
    button {
      height: 40px;
    }
  }
  .free_subscribe_section {
    height: 45vh;
    text-align: left;
    button {
      width: 60%;
      background-color: #fff;
      color: #31cc9a;
      margin-top: 10px;
      font-weight: 600;
      height: 40px;
      border-radius: 4px;
    }
  }
  #subscribe {
    background-color: #000;
    padding-top: 32px;
    padding-bottom: 32px;
    .contact_us_form {
      background-color: #000;
      p {
        font-size: 2.2em;
      }
      form {
        border-radius: 10px;
        input {
          height: 50px;
        }
        p {
          font-size: 12px;
        }
      }
      .btn_custom {
        background-color: #ffd54a !important;
        font-weight: 800;
        display: block;
        margin: 10px auto;
        height: 70px;
        width: 100%;
        max-width: 300px;
        box-sizing: border-box;
        color: #000;
        font-size: 1.6em;
      }
    }
  }
  #subscribe form {
    margin-top: 0px;
  }
}

/* Small Devices, Tablets */
@media only screen and (max-width: 768px) {
  #hero {
    margin-top: 0;
    h1 {
      font-weight: 700;
      font-size: 42px;
      line-height: 50px;
      color: #040d14;
      margin-bottom: 15px !important;
    }
    h4 {
      font-weight: 400;
      font-size: 17px;
      color: #696969;
      line-height: 24px;
      margin-bottom: 15px !important;
    }
    .btn_custom {
      margin: 0px !important;
    }
  }
  #services {
    margin-top: 16px;
  }
  .services {
    padding-top: 24px;
    padding-bottom: 24px;
  }
  #subscribe form {
    margin-top: 0px;
  }
  .free_report_section {
    text-align: center;
    height: 35vh;
    h2 {
      margin-top: 0px;
      font-size: 23px;
    }
    p {
      margin: 0px;
    }
    button {
      height: 40px;
    }
  }
  .free_subscribe_section {
    text-align: center;
    height: 40vh;
    button {
      width: 60%;
      background-color: #fff;
      color: #31cc9a;
      margin-top: 10px;
      font-weight: 600;
      height: 40px;
      border-radius: 4px;
    }
  }
  #subscribe {
    background-color: #000;
    padding-top: 24px;
    padding-bottom: 24px;
    .contact_us_form {
      background-color: #000;
      p {
        font-size: 2.2em;
      }
      form {
        border-radius: 10px;
        input {
          height: 50px;
        }
        p {
          font-size: 12px;
        }
      }
      .btn_custom {
        background-color: #ffd54a !important;
        font-weight: 800;
        display: block;
        margin: 10px auto;
        height: 70px;
        width: 100%;
        max-width: 300px;
        box-sizing: border-box;
        color: #000;
        font-size: 1.6em;
      }
    }
  }
}
/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
  #subscribe .contact_us_form form {
    padding: 16px !important;
  }
  #subscribe .contact_us_form .btn_custom {
    font-size: 1.3em;
    height: 60px;
  }
  #hero {
    h1 {
      font-weight: 700;
      font-size: 55px;
      line-height: 58px;
      color: #040d14;
      text-align: center;
    }
    h4 {
      font-weight: 400;
      font-size: 20px;
      color: #696969;
      line-height: 24px;
      text-align: center;
    }
    .home_page_banner {
      max-width: 85%;
      position: relative;
      bottom: 5vh;
      left: 6vw;
    }
    .btn_custom {
      background-color: #1a7055;
      color: #fff;
      font-weight: 600;
      margin: auto;
      height: 50px;
      width: auto;
      margin: auto !important;
      display: block;
    }
  }
  .services {
    padding-top: 0vh;
  }
  .services img {
    width: 85%;
    height: auto;
    position: relative;
    left: 5vw;
  }
  #testimonials {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .free_report_section {
    text-align: center;
    height: 30vh;
  }
  .free_subscribe_section {
    text-align: center;
    height: 30vh;
  }
  q {
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
  }
  .services h1 {
    font-weight: 700;
    font-size: 26px;
    line-height: 36px;
    color: #040d14;
    text-align: center;
  }
  .center_heading {
    text-align: center;
    font-size: 28px;
    font-weight: 700;
    line-height: 42px;
  }
  #services {
    margin-top: 0;
  }
}
@media only screen and (max-width: 375px) {
  #hero {
    h1 {
      font-weight: 700;
      font-size: 46px;
      line-height: 58px;
      color: #040d14;
    }
    h4 {
      font-weight: 400;
      font-size: 20px;
      color: #696969;
      line-height: 24px;
    }
    .home_page_banner {
      max-width: 85%;
      position: relative;
      bottom: 5vh;
      left: 6vw;
    }
    .btn_custom {
      background-color: #1a7055;
      color: #fff;
      font-weight: 600;
      margin: auto;
      height: 50px;
      width: auto;
      margin: auto !important;
      display: block;
    }
  }
  .services {
    padding-top: 0vh;
  }
  .services img {
    width: 85%;
    height: auto;
    position: relative;
    left: 5vw;
  }
  #testimonials {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .free_report_section {
    text-align: center;
    height: 30vh;
  }
  .free_subscribe_section {
    text-align: center;
    height: 30vh;
  }
  q {
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
  }
  .services h1 {
    font-weight: 700;
    font-size: 26px;
    line-height: 36px;
    color: #040d14;
    text-align: center;
  }
  .center_heading {
    text-align: center;
    font-size: 28px;
    font-weight: 700;
    line-height: 42px;
  }
  #services {
    margin-top: 0;
  }
}
/* Custom, iPhone Retina */
@media only screen and (max-width: 320px) {
  #subscribe .contact_us_form form {
    padding: 12px !important;
  }
  #subscribe .contact_us_form .btn_custom {
    font-size: 1.1em;
    height: 54px;
    width: 100%;
    max-width: 100%;
  }
  #hero {
    h1 {
      font-weight: 700;
      font-size: 36px;
      line-height: 40px;
      color: #040d14;
      text-align: center;
    }
    h4 {
      font-weight: 400;
      font-size: 16px;
      color: #696969;
      line-height: 20px;
      text-align: center;
    }
    .home_page_banner {
      max-width: 70%;
      position: relative;
      bottom: 5vh;
      left: 12vw;
    }
    .btn_custom {
      background-color: #1a7055;
      color: #fff;
      font-weight: 600;
      margin: auto;
      height: 50px;
      width: auto;
      margin: auto !important;
      display: block;
    }
  }
  #services {
    margin-top: 0;
  }
  .free_subscribe_section {
    text-align: center;
    min-height: 35vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue